<template>
  <div :class="wrpCls">
    <a-tooltip placement="bottom">
      <template slot="title">
        <span>文档</span>
      </template>
    </a-tooltip>
    <!-- <a-button type="primary" @click="show_chat" style="margin-right: 15px">客服中心</a-button> -->
    <avatar-dropdown :menu="showMenu" :current-user="currentUser" :class="prefixCls" />
    <select-lang :class="prefixCls" />
    <!-- 聊天界面 -->
    <div class="shade_bg" v-if="is_shwo_chat" >
      <div class="shade_center">
        <div class="center_l">
          <div class="l_t">
            <a-input class="a_serch" allowClear placeholder="搜索">
              <a-icon type="search" slot="prefix" />
            </a-input>
          </div>
          <div class="l_s">
            <div
              class="item"
              @click="show_user(index)"
              :style="{ background: index == idx ? 'rgb(233, 233, 233)' : '' }"
              v-for="(item, index) in users"
              :key="index"
            >
              <div class="img">
                <img :src="item.img" alt="" />
              </div>
              <div class="item_user">
                <div class="user_company">{{ item.company }}</div>
                <div class="user_name">{{ item.name }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="center_r">
          <span class="none" v-if="idx == -1">暂无聊天</span>
          <div class="r_s" v-else>
            <div class="r_t">
              <div class="r_t_u">
                <div class="company">{{ user_info.company }}</div>
                <div class="user">{{ user_info.name }}</div>
              </div>
              <a-icon type="close" @click="close_chat" class="close" />
            </div>
            <div class="charts">
              <div class="item_chat" v-for="(item, index) in charts" :key="index">
                <div :class="item.uid == 1 ? 'img2' : 'img'">
                  <img :src="item.img" alt="" />
                </div>
                <div :class="item.uid == 1 ? 'chat_v2' : 'chat_v'" v-html="item.val"></div>
              </div>
            </div>
            <div class="send">
              <div class="input" ref="feedback" @input="blurBook($event)" contenteditable="true"></div>
              <a-button class="primary" @click="sendVal" :disabled="feedback.length ? false : true" type="primary">
                发送
              </a-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AvatarDropdown from './AvatarDropdown'
import SelectLang from '@/components/SelectLang'

export default {
  name: 'RightContent',
  components: {
    AvatarDropdown,
    SelectLang,
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ant-pro-global-header-index-action',
    },
    isMobile: {
      type: Boolean,
      default: () => false,
    },
    topMenu: {
      type: Boolean,
      required: true,
    },
    theme: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showMenu: true,
      currentUser: {},
      users: [
        {
          uid: 2,
          img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg.zcool.cn%2Fcommunity%2F01ce9c5e835487a80120a8956349f4.jpg%401280w_1l_2o_100sh.jpg&refer=http%3A%2F%2Fimg.zcool.cn&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1640227832&t=2d69d147c6734297360b840e54ac3551',
          company: '杭州安联-研发部',
          name: '张公子',
          charts: [
            {
              uid: 2,
              img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg.zcool.cn%2Fcommunity%2F01ce9c5e835487a80120a8956349f4.jpg%401280w_1l_2o_100sh.jpg&refer=http%3A%2F%2Fimg.zcool.cn&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1640227832&t=2d69d147c6734297360b840e54ac3551',
              val: '你好，请问怎么打Dota？',
            },
            {
              uid: 1,
              img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fup.enterdesk.com%2Fedpic%2Fec%2Fca%2Fd8%2Feccad87a334d082b8ff200ae01157e44.jpg&refer=http%3A%2F%2Fup.enterdesk.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1640227832&t=3c3fdec2375ff54b450db92bcc30f91b',
              val: '你好，会扣工资的哦',
            },
          ],
        },
        {
          uid: 3,
          img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fc-ssl.duitang.com%2Fuploads%2Fitem%2F202002%2F08%2F20200208215620_WaahL.thumb.400_0.jpeg&refer=http%3A%2F%2Fc-ssl.duitang.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1640227832&t=a8b33d677005c0cb302e8d092c901782',
          company: '杭州安联-研发部',
          name: '陈少爷',
          charts: [
            {
              uid: 3,
              img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fc-ssl.duitang.com%2Fuploads%2Fitem%2F202002%2F08%2F20200208215620_WaahL.thumb.400_0.jpeg&refer=http%3A%2F%2Fc-ssl.duitang.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1640227832&t=a8b33d677005c0cb302e8d092c901782',
              val: '你好，工作日报怎么写',
            },
            {
              uid: 1,
              img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fup.enterdesk.com%2Fedpic%2Fec%2Fca%2Fd8%2Feccad87a334d082b8ff200ae01157e44.jpg&refer=http%3A%2F%2Fup.enterdesk.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1640227832&t=3c3fdec2375ff54b450db92bcc30f91b',
              val: '你猜',
            },
          ],
        },
        {
          uid: 4,
          img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fhbimg.b0.upaiyun.com%2F754de9c9044aa5ff11894f0d6f5502e2fc4e72144b71f-dBjf0p_fw658&refer=http%3A%2F%2Fhbimg.b0.upaiyun.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1640227832&t=46f302a2b7261dc444a68ab699e499f0',
          company: '杭州安联-研发部',
          name: '爱新觉罗',
          charts: [
            {
              uid: 4,
              img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fhbimg.b0.upaiyun.com%2F754de9c9044aa5ff11894f0d6f5502e2fc4e72144b71f-dBjf0p_fw658&refer=http%3A%2F%2Fhbimg.b0.upaiyun.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1640227832&t=46f302a2b7261dc444a68ab699e499f0',
              val: '测试测试',
            },
            {
              uid: 1,
              img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fup.enterdesk.com%2Fedpic%2Fec%2Fca%2Fd8%2Feccad87a334d082b8ff200ae01157e44.jpg&refer=http%3A%2F%2Fup.enterdesk.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1640227832&t=3c3fdec2375ff54b450db92bcc30f91b',
              val: '傻逼',
            },
          ],
        },
        {
          uid: 5,
          img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fb-ssl.duitang.com%2Fuploads%2Fitem%2F201803%2F26%2F20180326013240_wrjeh.jpeg&refer=http%3A%2F%2Fb-ssl.duitang.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1640227832&t=47d465f20925e0265e1203aa6e01c04e',
          company: '杭州安联-行政部',
          name: '用户1',
          charts: [
            {
              uid: 5,
              img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fb-ssl.duitang.com%2Fuploads%2Fitem%2F201803%2F26%2F20180326013240_wrjeh.jpeg&refer=http%3A%2F%2Fb-ssl.duitang.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1640227832&t=47d465f20925e0265e1203aa6e01c04e',
              val: '测试测试用户',
            },
          ],
        },
      ],
      idx: -1,
      feedback: '',
      charts: [],
      user_info: {
        company: '',
        name: '',
        uid: '',
        img: '',
      },
      is_shwo_chat:false
    }
  },
  computed: {
    wrpCls() {
      return {
        'ant-pro-global-header-index-right': true,
        [`ant-pro-global-header-index-${this.isMobile || !this.topMenu ? 'light' : this.theme}`]: true,
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.currentUser = {
        name: '若依',
      }
    }, 1500)
  },
  methods: {
    show_chat(){
      this.is_shwo_chat=true;
    },
    close_chat(){
      this.is_shwo_chat=false;
    },
    show_user(idx) {
      this.charts = this.users[idx].charts
      this.user_info.company = this.users[idx].company
      this.user_info.name = this.users[idx].name
      this.user_info.uid = this.users[idx].uid
      this.user_info.img = this.users[idx].img
      this.idx = idx
    },
    //内容改变
    blurBook(e) {
      this.feedback = e.target.innerText
    },
    sendVal() {
      // this.charts.push({
      //   uid: 1,
      //   img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fup.enterdesk.com%2Fedpic%2Fec%2Fca%2Fd8%2Feccad87a334d082b8ff200ae01157e44.jpg&refer=http%3A%2F%2Fup.enterdesk.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1640227832&t=3c3fdec2375ff54b450db92bcc30f91b',
      //   val: this.feedback,
      // })
      this.users[this.idx].charts.push({
        uid: 1,
        img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fup.enterdesk.com%2Fedpic%2Fec%2Fca%2Fd8%2Feccad87a334d082b8ff200ae01157e44.jpg&refer=http%3A%2F%2Fup.enterdesk.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1640227832&t=3c3fdec2375ff54b450db92bcc30f91b',
        val: this.feedback,
      })
      this.feedback = ''
      this.$refs.feedback.innerHTML = ''
    },
  },
}
</script>
<style scoped lang='less'>
.shade_bg {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999 !important;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  .shade_center {
    width: 60%;
    height: 80%;
    background: #fff;
    border-radius: 5px;
    .center_l {
      width: 25%;
      height: 100%;
      float: left;
      border-right: 1px solid #ddd;
      .l_t {
        width: 100%;
        height: 55px;
        float: left;
        border-bottom: 1px solid #ddd;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 15px;
        box-sizing: border-box;
        .a_serch {
          background: #eee !important;
        }
      }
      .l_s {
        width: 100%;
        height: calc(100% - 55px);
        float: left;
        background: #f5f5f5;
        .item {
          width: 100%;
          float: left;
          padding: 10px 15px;
          box-sizing: border-box;
          box-sizing: border-box;
          cursor: pointer;
          transition: 0.3s;
          &:hover {
            background: rgb(233, 233, 233);
          }
          .img {
            width: 40px;
            height: 40px;
            float: left;
            border-radius: 2px;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              float: left;
            }
          }
          .item_user {
            width: calc(100% - 50px);
            float: left;
            margin-left: 10px;
            height: 40px;
            line-height: initial;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            .user_company {
              width: 100%;
              float: left;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              font-size: 14px;
              color: #111;
            }
            .user_name {
              width: 100%;
              float: left;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              font-size: 13px;
              color: #555;
            }
          }
        }
      }
    }
    .center_r {
      width: 75%;
      height: 100%;
      float: left;
      position: relative;
      .none {
        font-size: 24px;
        color: rgb(187, 187, 187);
        font-family: fangsong;
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%);
      }
      .r_s {
        width: 100%;
        height: 100%;
        float: left;
        .r_t {
          width: 100%;
          height: 55px;
          float: left;
          line-height: initial;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          padding: 0 15px;
          box-sizing: border-box;
          border-bottom: 1px solid #eee;
          .r_t_u {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            .company {
              font-size: 14px;
            }
            .user {
              font-size: 13px;
            }
          }
          .close {
            font-size: 18px;
            margin-top: 10px;
            cursor: pointer;
            transition: 0.3s;
            &:hover {
              color: red;
            }
          }
        }
        .charts {
          width: 100%;
          height: calc(100% - 55px - 80px);
          float: left;
          background: #f8f8f8;
          .item_chat {
            width: 100%;
            float: left;
            padding: 0 15px;
            box-sizing: border-box;
            margin-top: 15px;
            .img {
              width: 40px;
              height: 40px;
              float: left;
              border-radius: 3px;
              overflow: hidden;
              img {
                width: 100%;
                height: 100%;
                float: left;
                object-fit: cover;
              }
            }
            .img2 {
              width: 40px;
              height: 40px;
              float: right;
              border-radius: 3px;
              overflow: hidden;
              img {
                width: 100%;
                height: 100%;
                float: left;
                object-fit: cover;
              }
            }
            .chat_v {
              max-width: calc(100% - 200px);
              float: left;
              line-height: 24px;
              margin-left: 15px;
              background: #fff;
              padding: 8px 13px;
              border-radius: 5px;
              font-size: 13px;
            }
            .chat_v2 {
              max-width: calc(100% - 200px);
              float: right;
              line-height: 24px;
              margin-right: 15px;
              background: #fff;
              padding: 8px 13px;
              border-radius: 5px;
              font-size: 13px;
            }
          }
        }
        .send {
          width: 100%;
          height: 80px;
          float: left;
          background: #eee;
          display: flex;
          justify-content: space-around;
          align-items: center;
          .input {
            width: calc(100% - 80px);
            float: left;
            height: 100%;
            line-height: 20px;
            padding: 2px 5px;
            box-sizing: border-box;
            outline: none;
            overflow-y: scroll;
            &::-webkit-scrollbar {
              width: 3px;
            }
            &::-webkit-scrollbar-thumb {
              border-radius: 10px;
              -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
              background: rgba(0, 0, 0, 0.2);
            }
            &::-webkit-scrollbar-track {
              -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
              border-radius: 0;
              background: rgba(0, 0, 0, 0.1);
            }
            &:empty:before {
              content: '请输入...';
              color: gray;
            }
            &:focus:before {
              content: none;
            }
          }
          .primary {
            font-size: 13px;
          }
        }
      }
    }
  }
}
</style>
